var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "popup",
        role: "dialog",
        "data-backdrop": "static",
        "data-keyboard": "false"
      },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", {
              staticClass: "popup-content",
              domProps: {
                innerHTML: _vm._s(
                  _vm.replaceHTMLSellerInfo(_vm.popupData.content)
                )
              }
            }),
            _vm._v(" "),
            _vm.popupData.noDispSuppression
              ? _c("div", { staticClass: "flex flex-content-center gap-10" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.noDipsOption,
                        expression: "noDipsOption"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: { type: "checkbox", id: "no-disp-option" },
                    domProps: {
                      checked: Array.isArray(_vm.noDipsOption)
                        ? _vm._i(_vm.noDipsOption, null) > -1
                        : _vm.noDipsOption
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.noDipsOption,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.noDipsOption = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.noDipsOption = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.noDipsOption = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "no-disp-option" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          "本メッセージを" +
                            _vm.popupData.noDispTerm +
                            "日間表示しない"
                        )
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "flex mr-t-10" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-normal",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.closePopup()
                    }
                  }
                },
                [_vm._v("閉じる")]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6be7b2a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be7b2a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Popup.vue
// module id = null
// module chunks = 